// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"04a72d053bfa09c6f587","655":"a4f599f8ad3e6112762b"}[chunkId] + ".js";
};